import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Button, Grid, IconButton, InputAdornment, Typography } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import TextField from 'libs/formik_fields/TextField';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';
import { LoadingButton } from '@mui/lab';
import SingleFileUploadField from 'libs/formik_fields/SingleFileUploadField';

const emptyData = {
    image: { url: '', key: '', new: false, loading: false }
};

const galleryImageFormSchema = yup.object().shape({
    image: yup.mixed().required('Please add image.')
});

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

const GalleryAddImageFormContent = ({ disabledFields = [], ...formik }) => {
    const { isSubmitting } = formik;

    const navigate = useNavigate();

    const handleBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const classes = useStyles();

    return (
        <Grid container spacing={0} py={2}>
            <Grid item xs={12} md={6} px={1}>
                <SingleFileUploadField name="image" label="Gallery image" accept="image/*" fileType="image" />
            </Grid>
            <Grid item xs={12} px={1}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Save
                </LoadingButton>
            </Grid>
        </Grid>
    );
};

function GalleryAddImageForm({ handleSubmit, initialValues, disabledFields }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues ?? emptyData}
            onSubmit={handleSubmit}
            validationSchema={galleryImageFormSchema}
            FormContent={GalleryAddImageFormContent}
            disabledFields={disabledFields}
        />
    );
}

export default GalleryAddImageForm;
